import { graphql } from '../../graphql';

export const readNotification = graphql(`
  mutation ReadNotification($id: ID!) {
    readNotification(input: { id: $id }) {
      errors {
        code
        message
        path
      }
    }
  }
`);
